/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./get-verification-code.vue?vue&type=template&id=66a13dc5&scoped=true"
import script from "./get-verification-code.vue?vue&type=script&lang=js"
export * from "./get-verification-code.vue?vue&type=script&lang=js"
import style0 from "./get-verification-code.vue?vue&type=style&index=0&id=66a13dc5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a13dc5",
  null
  
)

export default component.exports